import { PrivilegeLevels } from './PrivilegeLevels';

/**
 * For addon page routes, must include `addonControl` property.
 *
 * `addonControl` = 'collaboration' | 'engagement' | 'trackerAI' (update if more addons)
 */
export const RouteInformation = {
  serviceLog: {
    privilegeRequirement: PrivilegeLevels.user.level,
    path: '/service-log',
  },
  serviceLogIndividualService: {
    privilegeRequirement: PrivilegeLevels.user.level,
    path: '/service-log/:serviceId',
  },
  mediaInteraction: {
    privilegeRequirement: PrivilegeLevels.user.level,
    path: '/interactions',
  },
  mediaInteractionIndividualIssue: {
    privilegeRequirement: PrivilegeLevels.user.level,
    path: '/interactions/:issueId',
  },
  engagementLog: {
    privilegeRequirement: PrivilegeLevels.user.level,
    path: '/engagement-log',
    addon: 'engagement',
  },
  engagementLogIndividualEngagement: {
    privilegeRequirement: PrivilegeLevels.user.level,
    path: '/engagement-log/:engagementId',
    addon: 'engagement',
  },
  calendar: {
    privilegeRequirement: PrivilegeLevels.user.level,
    path: '/calendar',
  },
  contacts: {
    privilegeRequirement: PrivilegeLevels.user.level,
    path: '/contacts',
  },
  teamAnalytics: {
    privilegeRequirement: PrivilegeLevels.manager.level,
    path: '/team-analytics',
  },
  customAnalytics: {
    privilegeRequirement: PrivilegeLevels.manager.level,
    path: '/custom-analytics',
  },
  report: {
    privilegeRequirement: PrivilegeLevels.manager.level,
    path: '/report',
  },
  admin: {
    privilegeRequirement: PrivilegeLevels.manager.level,
    path: '/admin',
  },
  tenants: {
    privilegeRequirement: PrivilegeLevels.broadsightAdmin.level,
    path: '/tenants',
  },
  profile: {
    privilegeRequirement: PrivilegeLevels.user.level,
    path: '/profile',
  },
  feedback: {
    privilegeRequirement: PrivilegeLevels.user.level,
    path: 'https://rfsfn.share.hsforms.com/2xoYLix8AS2GwULlo04vwew',
  },
  notifications: {
    privilegeRequirement: PrivilegeLevels.user.level,
    path: '/notifications',
  },
  collaboration: {
    privilegeRequirement: PrivilegeLevels.manager.level,
    path: '/collaboration',
    addonControl: 'collaboration',
  },
  broadcastPopup: {
    privilegeRequirement: PrivilegeLevels.user.level,
    path: '/broadcast-popup',
  },
};
